<template>
  <div
    class="percentage-bar-container"
    :class="{ 'percentage-bar-container--compact': barOnly }"
    :style="barOnly ? null : 'width: 300px;'"
  >

    <small v-if="!small && !barOnly" class="text-primary">Today F.C: {{targetresult.avg_today_new_emails}} avg<br></small>
    <small v-if="!small && !barOnly" class="text-primary">Tomorrow F.C: {{targetresult.avg_tomorrow_new_emails}} avg<br></small>

    <div v-if="small && !barOnly">
      <div class="row">
        <small class="ml-3" >Total BD: {{ totalContacts }}</small>
        <small class="ml-2 mr-4" v-if="targetresult.salesridge_data && targetresult.salesridge_data.uniqueLeads && totalSalesridge"> (SR: {{ totalSalesridge }})</small><br>
        <span class="font-weight-bold"> <Tooltip :text="'Available'">A: {{ availableContacts }}</Tooltip> - <Tooltip :text="'Used'">U: {{ targetresult.used }}</Tooltip> - <Tooltip :text="'Not available'">N: {{notAvailableContacts-targetresult.used}}</Tooltip> </span>
      </div>
    </div>
    <div v-else-if="!small && !barOnly">
    <small >Total BD: {{ totalContacts }}</small>
    <small v-if="targetresult.salesridge_data && targetresult.salesridge_data.uniqueLeads && totalSalesridge"> (SR: {{ totalSalesridge }})</small><br>
    </div>
    <!-- Barra de porcentaje -->
   <div
    class="percentage-bar-track mb-2"
    :class="{
      'percentage-bar-track--compact': barOnly,
      'row px-3': !barOnly,
    }"
   >
      <div v-if="totalUsedPercentage > 0" class=" blue-bar p-1" :style="{ width: Number(totalUsedPercentage-1)+ '%' }">
        {{ totalUsedPercentage }}%
      </div>
      <div v-if="totalNotValidPercentage > 0" class=" red-bar p-1" :style="{ width: Number(totalNotValidPercentage-1)+ '%' }">
        {{ totalNotValidPercentage.toFixed(2) }}%
      </div>

      <div class=" green-bar p-1" :style="{ width: Number(totalValidPercentage-10)+ '%' }">
        {{ totalValidPercentage }}%
      </div>
      

    </div>
    <!-- Fin Barra de porcentaje -->
    <div class="legend" v-if="!small && !barOnly">

      <div class="legend-item">
        <span class="legend-item" v-if="targetresult.used">
          <small><span class="legend-color blue-bar mr-2"></span>{{totalUsedPercentage}}% Used {{ targetresult.used }} of {{totalContacts}} (Used + Planified Today, Tomorrow) 
            <Tooltip :text="'The contacts in the scheduling queue for today or tomorrow depend on the time you check this. They will be from today or tomorrow.'" :width="'130px'"><i class="icon icon-question cursor-pointer"></i></Tooltip></small>
        </span>
      </div>
      <div class="legend-item">
        <span class="legend-color green-color"></span>
        <small>{{ validWithinImportedPercentage.toFixed(1) }}% Available ({{ availableContacts }} of {{totalContacts}})</small>
      </div>

      <small class="legend-item pl-4" v-if="targetresult.contactedtoday">
        <small>- Contacted today in another target ({{ targetresult.contactedtoday }})</small>
      </small>

      <div class="legend-item">
        <span class="legend-color red-color"></span>
        <small>{{ totalNotValidPercentage.toFixed(1) }}% Not available ({{notAvailableContacts-targetresult.used}} of {{totalContacts}})</small> 
      </div>
      <div>
        <small class="legend-item pl-4" v-if="targetresult.donotcontact">
          <small>- Do not contact ({{ targetresult.donotcontact }})</small>
        </small>
        <small class="legend-item pl-4" v-if="targetresult.notvalidstatus">
          <small>- Not valid status ({{ targetresult.notvalidstatus }})</small>
        </small>
          <small class="legend-item pl-4" v-for="(st,i) in targetresult.notvalidstatus_by_status" :key="i">
             <small><small class="pl-3">. {{i}}: {{st}}   </small>  </small> 
          </small> 
        <small class="legend-item pl-4" v-if="targetresult.oliveroff">
          <small>- Oliver off ({{ targetresult.oliveroff }})</small>
        </small>
        <small class="legend-item pl-4" v-if="targetresult.blacklist">
          <small>- Blacklist ({{ targetresult.blacklist }})</small>
        </small>
        <small class="legend-item pl-4" v-if="targetresult.businessalreadycontacted">
          <small>- Business already contacted ({{ targetresult.businessalreadycontacted }})</small>
        </small>
        <small class="legend-item pl-4" v-if="targetresult.oliveroff6month">
          <small>- Oliver off 6 months ({{ targetresult.oliveroff6month }})</small>
        </small>
        <small class="legend-item pl-4" v-if="targetresult.alreadyhasevent">
          <small>- Has event ({{ targetresult.alreadyhasevent }})</small>
        </small>
        <small class="legend-item pl-4" v-if="targetresult.oppnotscope">
          <small>- Not scope ({{ targetresult.oppnotscope }})</small>
        </small>
        <small class="legend-item pl-4" v-if="targetresult.businesscontactuser">
          <small>- Business contact user ({{ targetresult.businesscontactuser }})</small>
        </small>
      </div>

    </div>
    <div v-if="targetresult.salesridge_data && targetresult.salesridge_data && !small && !barOnly" class="card p-1">
        <span v-if="targetresult.salesridge_data.ready" class="text-primary"><span class="icon-circle"></span> importing</span>
        <span v-if="targetresult.salesridge_data.batches > 0 && targetresult.salesridge_data.batches == targetresult.salesridge_data.exported" class="text-primary"><span class="icon-circle"></span> Import finished</span>
        <span v-if="targetresult.salesridge_data.batches == 0" class="text-danger"><span class="icon-circle"></span> importing</span>

        <span v-if="targetresult.salesridge_data && targetresult.salesridge_data.uniqueLeads && totalSalesridge && targetresult.import_success">Imported SR: {{ targetresult.import_success }} (of {{ totalSalesridge }} potential <Tooltip :text="'This number can change because it is Salesridge who calculates its dynamically on live'" :width="'130px'"><i class="icon icon-question cursor-pointer"></i></Tooltip>)</span>
        <span v-else-if="!targetresult.import_success && targetresult.salesridge_data.batches > 0 && targetresult.salesridge_data.batches == targetresult.salesridge_data.exported">Imported SR: {{ totalSalesridge }} (of {{ totalSalesridge }})</span>
      <div class="float-right"><small>#{{targetresult.salesridge_data.order}}</small></div>
      <strong v-if="!targetresult.last_attempt">Last import: +1 day</strong>
      <strong v-else>Last import: {{targetresult.last_attempt}}</strong>
      <div>
        <small >Total batches: {{ targetresult.salesridge_data.batches }}</small>
        <small v-if="targetresult.salesridge_data.ready"> Waiting: {{ targetresult.salesridge_data.ready }}</small>
        <small> Imported: {{ targetresult.salesridge_data.exported }}</small>
      </div>
    </div>
    <span v-else-if="!small && !barOnly" class="text-muted"><span class="icon-circle"></span> SalesRidge stats not loaded</span>
  </div>
</template>

<script>
import Tooltip from "@/components/Common/Tooltip.vue";


export default {
  name: "PercentageBar",
  components: {
    Tooltip
  },
  props: {
    targetresult: {
      type: Object,
      required: true,
    },
    target_id: {
      type: [Number, String],
      required: false,
    },
    small:{
      type:Boolean,
      default:false
    },
    barOnly: {
      type: Boolean,
      default: false,
    },
  },
  created(){
    if(!this.targetresult.used){
      this.targetresult.used = 0;
    }
  },
  watch: {
    availableContacts: {
      handler(newValue) {
        if (this.target_id !== undefined && this.target_id !== false) {
          this.$emit('getAvailableContacts', {
            target_id: this.target_id,
            availableContacts: newValue
          });
        }
      },
      immediate: true
    }
  },
  computed: {
    notAvailableContacts(){

      let keys = [
        'businesscontactuser',
        'donotcontact',
        'notvalidstatus',
        'oliveroff',
        'used',
        'blacklist',
        'businessalreadycontacted',
        'oliveroff6month',
        'alreadyhasevent',
        'oppnotscope'
      ];

      let total = 0;

      keys.forEach(key => {
        total += Number(this.targetresult[key] || 0);
      });


      return total;
    },
    availableContacts(){
      // Use same denominator as Total BD / percentages (totalContacts), not only
      // total_contacts.total_contacts — those can differ when SR uniqueLeads > BD row count.
      const total = Number(this.totalContacts) || 0;
      const unavailable = Number(this.notAvailableContacts) || 0;
      let available = total - unavailable;

      if (!Number.isFinite(available) || available < 0) {
        return 0;
      }
      return available;
    },

    totalSalesridge(){
      if(!this.targetresult.import_success){
        this.targetresult.import_success = 0;
      }

      if(this.targetresult.salesridge_data && this.targetresult.salesridge_data.uniqueLeads > this.targetresult.import_success){
        return this.targetresult.salesridge_data.uniqueLeads
      }
      return this.targetresult.import_success
    }, 
    totalContacts() {
        const { total_contacts, salesridge_data, import_success } = this.targetresult;
        const uniqueLeads = salesridge_data && salesridge_data.uniqueLeads;

        // Asegura que los valores sean números
        const total = Number(total_contacts) || 0;
        const leads = Number(uniqueLeads) || 0;
        const success = Number(import_success) || 0;

        return Math.max(total, leads, success);
        

      },
    totalContactsOliver(){
        const uniqueLeads = (this.targetresult.salesridge_data && this.targetresult.salesridge_data.uniqueLeads) || 0;
        return this.targetresult.total_contacts.total_contacts - uniqueLeads;
    },
    contactedPercentage(){
      return ( (this.targetresult.used * 100) / this.totalContacts).toFixed(2);
    },
    totalImportedPercentage() { //total improtados sobre el total
      return ( (this.targetresult.imported * 100) / this.totalContacts).toFixed(2);
    },
    totalValidPercentage() { //total improtados sobre el total
      return ( (this.availableContacts * 100) / this.totalContacts).toFixed(2);
    },
    totalNotValidPercentage() { 
      return ((Number(this.notAvailableContacts) * 100) / this.totalContacts).toFixed(2) - Number(this.totalUsedPercentage);
    },
    totalUsedPercentage() { 
      return ( (this.targetresult.used * 100) / this.totalContacts).toFixed(2);
    },
    validWithinImportedPercentage() {

      return ((this.availableContacts / this.totalContacts) * 100);
    },
    notValidWithinImportedPercentage() {
      return ((this.notAvailableContacts / this.totalContacts) * 100);
    },
  },
};
</script>

<style scoped>
.percentage-bar-container {
  width: 100%;
}

.percentage-bar-container--compact {
  width: 100%;
  min-width: 0;
}

.percentage-bar-track {
  height: 19px;
  overflow: hidden;
  font-size: 8px;
  color: white;
}

.percentage-bar-track--compact {
  display: flex;
  margin: 0 !important;
  padding: 0 !important;
}

.progress-bar {
  height: 30px;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: stretch;
  box-sizing: border-box;
}

.gray-bar {
  background-color: #e0e0e0;
  width: 100%;
  border: 1px solid #bdbdbd;
}

.blue-bar {
  background-color: #2196F3;
  transition: width 0.3s ease;
  min-width: 0;
}

.green-bar {
  background-color: #4CAF50;
  transition: width 0.3s ease;
  min-width: 0;
}

.red-bar {
  background-color: #f44336;
  transition: width 0.3s ease;
  min-width: 0;
}

.legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
  font-size: 0.875rem;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 2px;
  display: inline-block;
}

.gray-color {
  background-color: #e0e0e0;
  border: 1px solid #bdbdbd;
}

.green-color {
  background-color: #4CAF50;
}

.red-color {
  background-color: #f44336;
}
</style>
